// src/components/common/TagInput.jsx
import React, { useState } from 'react';
import { Plus, X, Tag as TagIcon } from 'lucide-react';

export const TagInput = ({ 
  tags = [], 
  onChange, 
  maxTags = null, 
  placeholder = "Add tags...",
  label = null,
  showCount = false
}) => {
  const [inputValue, setInputValue] = useState('');

  const addTag = () => {
    const trimmedValue = inputValue.trim();
    
    if (!trimmedValue) return;
    if (tags.includes(trimmedValue)) {
      alert('Tag already exists');
      return;
    }
    if (maxTags && tags.length >= maxTags) {
      alert(`Maximum ${maxTags} tags allowed`);
      return;
    }

    onChange([...tags, trimmedValue]);
    setInputValue('');
  };

  const removeTag = (indexToRemove) => {
    onChange(tags.filter((_, index) => index !== indexToRemove));
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      addTag();
    }
  };

  return (
    <div className="space-y-3">
      {label && (
        <label className="flex items-center justify-between text-sm font-medium text-gray-700">
          <span className="flex items-center gap-2">
            <TagIcon className="h-4 w-4" />
            {label}
          </span>
          {showCount && maxTags && (
            <span className="text-xs text-gray-500">
              {tags.length} / {maxTags}
            </span>
          )}
        </label>
      )}
      
      <div className="flex gap-2">
        <input
          type="text"
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
          onKeyPress={handleKeyPress}
          placeholder={placeholder}
          className="flex-1 px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
          disabled={maxTags && tags.length >= maxTags}
        />
        <button
          type="button"
          onClick={addTag}
          disabled={!inputValue.trim() || (maxTags && tags.length >= maxTags)}
          className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors flex items-center gap-2"
        >
          <Plus className="h-4 w-4" />
          Add
        </button>
      </div>

      {tags.length > 0 && (
        <div className="flex flex-wrap gap-2">
          {tags.map((tag, index) => (
            <span
              key={index}
              className="inline-flex items-center gap-1 px-3 py-1 bg-blue-100 text-blue-800 rounded-full text-sm"
            >
              {tag}
              <button
                type="button"
                onClick={() => removeTag(index)}
                className="text-blue-600 hover:text-blue-800 transition-colors"
              >
                <X className="h-3 w-3" />
              </button>
            </span>
          ))}
        </div>
      )}
    </div>
  );
};